import { secondaryMarketKycActionsFactory } from 'state/secondaryMarket/shared/kyc/kyc.action';

export const liveKycActions = secondaryMarketKycActionsFactory<'LIVE'>('LIVE');
type TypeofLiveKycActions = typeof liveKycActions;
export type SecondaryMarketLiveKycStatusFailed = ReturnType<TypeofLiveKycActions['secondaryMarketKycStatusFailed']>;
export type SecondaryMarketLiveKycStatusReceived = ReturnType<TypeofLiveKycActions['secondaryMarketKycStatusReceived']>;
export type SecondaryMarketLiveKycStatusRequested = ReturnType<
  TypeofLiveKycActions['secondaryMarketKycStatusRequested']
>;
export type SecondaryMarketLiveKycStatusReset = ReturnType<TypeofLiveKycActions['secondaryMarketKycStatusReset']>;

export type SecondaryMarketLiveKycActions = ReturnType<TypeofLiveKycActions[keyof TypeofLiveKycActions]>;
